var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Profile as ProfileModel } from "./../models/V1/Profiles/Profile";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
export class Profile {
  /**
   * Creates an instance of Profile.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof Profile
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetProfileRq_ _getProfileRq
   * @returns Promise<GetProfileRq_>
   * @memberof Profile
   */
  getProfile(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Profile", "GET", "application/json; charset=UTF-8", "application/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, clazz: ProfileModel }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateProfileRq_ _updateProfileRq
   * @returns Promise<UpdateProfileRq_>
   * @memberof Profile
   */
  updateProfile(pUpdateProfileRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Profile", "PATCH", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addBody({ value: pUpdateProfileRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
